<template>
  <div class="outer-layer">
    <label>项目所属投放账户：</label>
    <el-select v-model="projectData.advertiser_id" placeholder="请选择" size="mini" filterable @change="advertiserIdChange">
      <el-option
        v-for="option in projectConfig.project_form_option.advertiser_id_option"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      />
    </el-select>
    <el-button type="success" plain size="mini" style="float: right; margin-left: 10px;" @click="openTemplateList('project')">读取模板</el-button>
    <el-button v-if="projectData.advertiser_id" type="primary" plain size="mini" style="float: right" @click="openTemplateDialog('project')">保存模板</el-button>
    <div v-show="projectData.advertiser_id" class="project-container">
      <div v-for="(col, cKey) in 3" :key="cKey" class="project-column" :class="`col-${cKey}`">
        <div
          v-for="(project, key, i) in projectFilterData"
          :key="key"
        >
          <el-card
            v-if="(cKey === 0 && i < 3) || (cKey === 1 && i >= 3 && i < 6) || (cKey === 2 && i === 6)"
            shadow="never"
            style="margin: 10px"
          >
            <div style="display: flex; justify-content: space-between;">
              <h2>{{ project.title }}</h2>
              <div style="display: flex; align-items: center;">
                <el-button type="primary" plain size="mini" @click="openTemplateDialog(key, i)">保存模板</el-button>
                <el-button type="success" plain size="mini" @click="openTemplateList(key)">读取模板</el-button>
              </div>
            </div>
            <app-form
              :ref="'project_form'"
              :form-data="project.config"
              :submit-request="onSubmit"
              :is-show-button="false"
              default-label-width="120px"
            >
              <template #custom="{form_item, form_key}">
                <!-- 微信/字节小游戏 -->
                <div v-if="form_key === 'micro_app_instance_id'">
                  <el-button type="primary" @click="openMiniProgramAssets">选择小游戏</el-button>
                  <div v-if="form_item.value">
                    {{ `${JSON.parse(form_item.value)?.asset_name}(${JSON.parse(form_item.value)?.micro_app_id})` }}
                  </div>
                </div>
                <!-- 下载链接 -->
                <span v-if="form_key === 'download_url'">
                  <el-button
                    type="primary"
                    @click="openAssetBox"
                  >
                    选择应用
                  </el-button>
                  <div>
                    <span>{{ form_item.app_name }}</span>
                  </div>
                </span>
                <!-- 定向包 -->
                <audience
                  v-if="form_key === 'crowd_pack' || form_item.type === 'slider'"
                  :form-item="form_item"
                  :form-key="form_key"
                  :advertiser-id="projectData.advertiser_id"
                  style="min-width: 500px"
                />
                <!-- 投放时间段 -->
                <div v-if="form_key === 'schedule_time'" class="launch-style">
                  <keep-alive include="schedule-time">
                    <schedule-time
                      ref="ScheduleTime"
                      preele="outer-layer"
                      :time="form_item.value"
                    />
                  </keep-alive>
                </div>
                <div v-if="form_key === 'name'">
                  {{ projectWildcard }}
                </div>
              </template>
            </app-form>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 选择事件资产弹框 -->
    <event-asset-box
      v-if="event_asset_box_params.is_show"
      :is-open="event_asset_box_params.is_show"
      :tablep="event_asset_box_params.tablep"
      @confirm="eventAssetConfirm"
      @cancel="event_asset_box_params.is_show = false"
    />
    <!-- 模板弹框 -->
    <templateDialog
      v-if="template_dialog_config.is_show"
      :template-config="template_dialog_config"
      @confirm="confirmTemplateDialog"
    />
    <!-- 模板列表 -->
    <templateList
      v-if="template_list_config.is_show"
      :template-list-config="template_list_config"
      @confirm="applicationTemplate"
    />
    <el-dialog
      v-if="mini_program_assets_dialog_config.is_show"
      :visible.sync="mini_program_assets_dialog_config.is_show"
      v-bind="mini_program_assets_dialog_config.dialog_props"
    >
      <mini-program-assets
        v-if="mini_program_assets_dialog_config.is_show"
        :mg-type="mini_program_assets_dialog_config.mg_type"
        v-bind="mini_program_assets_dialog_config.getters.getAssetsProps()"
        @confirm="miniProgramAssetsConfirm"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getChannelDetailsApi } from '@/api/channel';

import EventManager from '@/api/tool/event-manager/jrtt';
const eventManager = new EventManager();

import InterestActionResource from '@/api/tool/interest-action/jrtt';
const interestActionResource = new InterestActionResource();

import TemplateResource from '@/api/template';
const templateResource = new TemplateResource();

import { getDeepBidTypeApi } from '@/api/tool/event-manager/deep-bid-type/jrtt';
import { getOptimizedGoalV2Api } from '@/api/tool/event-manager/optimized-goal-v2/jrtt';
import { formDataAssign, checkboxFilterNone } from '@/tools/form';
import { isArray } from '@/utils/is';
import { clone } from '@/utils';
import store from '@/store';

export default {
  components: {
    'app-form': () => import('@/components/app-form'),
    'schedule-time': () => import('@/components/schedule-time'),
    'audience': () => import('../../project-manage/components/audience'),
    'event-asset-box': () => import('../../project-manage/components/event-asset-box'),
    'templateDialog': () => import('./templateDialog.vue'),
    'templateList': () => import('./templateList.vue'),
    'mini-program-assets': () => import('@/views/superior/jrtt/components/mini-program-assets'),
  },
  props: {
    /** 项目数据 */
    projectData: {
      type: Object,
      default: null,
    },
    /** 项目配置 */
    projectConfig: {
      type: Object,
      default: null,
    },
  },
  inject: ['sharing_districts_map'],
  data() {
    return {
      /** 事件弹框参数 */
      event_asset_box_params: {
        is_show: false,
        tablep: {},
        key: '',
        checkList: [],
      },
      /** 模板弹窗配置 */
      template_dialog_config: {
        is_show: false,
        name: '',
        type: '',
        is_validate: true,
      },
      /** 模板列表配置 */
      template_list_config: {
        is_loading: false,
        is_show: false,
        type: '',
      },
      /** 项目模板 */
      project_template: {},
      /** 模板类型表 */
      template_type_map: {
        project: 'project',
        basic_set_form: 'project_base_param',
        target_form: 'project_delivery_content',
        optimize_form: 'project_optimize_goal',
        delivery_range_form: 'project_delivery_range',
        audience_form: 'project_audience',
        delivery_setting_form: 'project_delivery_setting',
        channel_form: 'channel',
      },
      game_value: null,
      /** 小程序资产弹窗配置 */
      mini_program_assets_dialog_config: {
        is_show: false,
        mg_type: '', // 小游戏类型 - 微信、字节
        dialog_props: {
          title: '请选择事件资产',
          width: '800px',
        },
        getters: {
          getAssetsProps: () => {
            const { advertiser_id, basic_set_form: { config: { landing_type, ad_type }}} = this.projectData;
            return {
              assetType: 'MINI_PROGRAME', // 该【PROGRAME】单词为官方写错，后端v1版本暂时与官方文档一致
              advertiserId: advertiser_id,
              landingType: landing_type.value,
              adType: ad_type.value,
            };
          },
        },
      },
      /** 字节小游戏数据备份 */
      byte_game_backup: {},
    };
  },
  computed: {
    /** 项目表单过滤广告ID参数 */
    projectFilterData: function() {
      return Object.fromEntries(Object.entries(this.projectData).filter(([key, val]) =>
        key !== 'advertiser_id' &&
        key !== 'promotion_batch_params' &&
        key !== 'project_config'));
    },
    /** 项目名称通配符显示 */
    projectWildcard: function() {
      const { alias: { extra_data = {}} = {}} = this.projectData.channel_form.config.channel.children;
      const { channel_details = {}} = extra_data;
      const { alias, config: { platform } = {}, game_id } = channel_details;
      return `jrttnew${alias ? '+' + alias : ''}${platform ? '++' + platform : ''}${game_id ? '+' + game_id : ''}`;
    },
  },
  watch: {
    projectConfig: {
      handler(newVal) {
        this.setGameData(newVal.project_form_option.game_id);
      },
      deep: true,
    },
    sharing_districts_map: {
      handler() {
        this.forceUpdateDistrict();
      },
      deep: true,
    },
  },
  created() {
    this.basicSetEvent();
    this.setGameData(this.projectConfig.project_form_option.game_id);
  },
  methods: {
    /** 基础设置事件监听 */
    basicSetEvent() {
      const { landing_type, app_promotion_type, delivery_mode } = this.projectData.basic_set_form.config;
      const { audience } = this.projectData.audience_form.config;
      const { platform, download_url, download_type, download_mode, launch_type, open_url, ulink_url, subscribe_url, micro_promotion_type, micro_app_instance_id } = this.projectData.target_form.config;
      const { external_action, deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
      const { deep_bid_type, bid_type, deep_cpabid } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const { alias } = this.projectData.channel_form.config.channel.children;

      if (landing_type && app_promotion_type) {
        // 【推广子目标】事件监听
        app_promotion_type.on = {
          change: this.appPromotionTypeChange,
        };

        // 【投放内容与目标-平台】事件监听
        platform.on = {
          change: () => {
            this.getAssetsList();
            // 同步定向包平台字段
            const is_micro_game = (landing_type.value === 'MICRO_GAME');
            !is_micro_game && (audience.children.platform.value = [platform.value]);
          },
        };

        // 【下载链接】事件监听
        download_url.on = {
          change: this.downloadUrlChange,
        };

        /** 深度优化目标默认的事件监听【为了处理刷新页面后深度优化目标未绑定change事件问题】 */
        if (!deep_external_action?.on?.change) {
          deep_external_action.on = {
            change: () => {
              this.onDeepExternalActionChange();
            },
          };
        }

        // 【优化目标】事件监听
        external_action.on = {
          change: (val) => {
            if (val) {
              deep_external_action.value = '';
            }

            const index = external_action.options.findIndex(item => {
              return item.value === external_action.value;
            });

            if (index !== -1) {
              const temp_deep_goals = external_action.options[index]?.deep_goals;
              const deep_bid_types = external_action.options[index]?.deep_bid_types;
              if (temp_deep_goals) {
                deep_external_action.options = temp_deep_goals.map(item => {
                  return {
                    label: item.optimization_name,
                    value: item.deep_external_action,
                    deep_bid_type: item.deep_bid_type,
                    deep_bid_type_name: item.deep_bid_type_name,
                  };
                });
                deep_external_action.hidden = false;
              } else {
                deep_external_action.hidden = true;
              }

              if (deep_bid_types?.length) {
                deep_bid_type.options = deep_bid_types.map(item => {
                  // 深度优化方式存在【每次付费】选项时默认选中【每次付费】
                  if (item.deep_bid_type === 'BID_PER_ACTION') {
                    deep_bid_type.value = 'BID_PER_ACTION';
                  }
                  return {
                    label: item.name,
                    value: item.deep_bid_type,
                  };
                });

                deep_bid_type.hidden = false;
              } else {
                deep_bid_type.options = [];
                deep_bid_type.hidden = true;
              }
            } else {
              // 读取模板时优化目标的值与选项不匹配时清空值
              external_action.value = '';
            }

            /** 如果优化目标等于 AD_CONVERT_TYPE_PAY，不管获取可用优化目标接口有没有返回深度优化目标，都需要请求该接口 */
            if (external_action.value === 'AD_CONVERT_TYPE_PAY') {
              this.setDeepBidTypeProperty();
            }
            deep_bid_type?.on?.change?.();
            this.setRoiGoalProperty();

            // 深度优化目标事件监听
            deep_external_action.on = {
              change: () => {
                const index = deep_external_action.options.findIndex(item => {
                  return item.value === deep_external_action.value;
                });

                if (index !== -1) {
                  const temp_deep_bid_type = deep_external_action.options[index]?.deep_bid_type;
                  const temp_deep_bid_type_name = deep_external_action.options[index]?.deep_bid_type_name;
                  if (temp_deep_bid_type) {
                    deep_bid_type.options = [{
                      label: temp_deep_bid_type_name,
                      value: temp_deep_bid_type,
                    }];

                    deep_bid_type.value = temp_deep_bid_type;
                    deep_bid_type.hidden = false;
                  } else {
                    deep_bid_type.hidden = true;
                  }
                } else {
                  external_action.on.change();
                  deep_bid_type?.on?.change?.();
                }
                this.onDeepExternalActionChange();
              },
            };
          },
        };

        /** 深度优化方式事件监听 */
        deep_bid_type.on = {
          change: () => {
            /** 深度优化出价，deep_bid_type = DEEP_BID_MIN 时必填。取值范围：0.1~10000元 注意：当 bid_type = NO_BID时，不填写该字段，否则会报错 */
            const is_deep_bid_min = deep_bid_type.value === 'DEEP_BID_MIN';
            const is_no_bid = bid_type.value === 'NO_BID';
            /** 深度优化方式是【显示】且值为【DEEP_BID_MIN】时显示【深度优化出价】 */
            deep_cpabid.hidden = !(is_deep_bid_min && !deep_bid_type.hidden);
            if (is_no_bid) {
              deep_cpabid.hidden = true;
            }
          },
        };

        // 【推广目的】事件监听
        landing_type.on = {
          change: async(val) => {
            const is_micro_game = landing_type.value === 'MICRO_GAME';
            /** 推广目的为小游戏时，推广子目标控制隐藏 */
            app_promotion_type.hidden = is_micro_game;
            /** 推广目的为小游戏时,投放内容与目标模块显示小游戏类型 */
            micro_promotion_type.options = this.$store.getters.jrttEnum.api_2_micro_promotion_type || [];
            micro_promotion_type.hidden = !is_micro_game;

            /** 推广目的为小游戏时,已安装用户只支持 不限（UNLIMITED）*/
            const { audience: { children: { hide_if_exists }}} = this.projectData.audience_form.config;
            is_micro_game && (hide_if_exists.value = 'UNLIMITED');
            hide_if_exists.options.forEach(opt => (opt.disabled = (is_micro_game && opt.value !== `UNLIMITED`)));

            /** 推广目标为小游戏的时候, 投放内容与目标只显示`小游戏类型` */
            [subscribe_url, ulink_url, open_url, launch_type, download_url, download_type, download_mode, platform].forEach(field => (field.hidden = is_micro_game));

            /** 显示【投放模式】 */
            delivery_mode.hidden = false;

            /** 推广目标不为小游戏时，主动触发推广子目标改变事件，初始化投放内容与目标的表单显示 */
            !is_micro_game && this.appPromotionTypeChange();

            /** 推广目标切换时，主动触发广告主账号改变事件以获取最新的资产列表和优化目标数据 */
            await this.advertiserIdChange();

            /** 隐藏资产列表 */
            const { optimize_goal: { children: { asset_ids }}} = this.projectData.optimize_form.config;
            asset_ids.hidden = is_micro_game;

            /** 推广目标为小游戏的时候，定向包-平台允许自由选择 */
            audience.children.platform.disabled = !is_micro_game;
            !is_micro_game && (audience.children.platform.value = [platform.value]);

            /** 读取模板时不执行 */
            if (val) {
              /** 推广目标改变时，清空优化目标的值并隐藏深度优化目标 */
              external_action.value = '';
              deep_external_action.hidden = true;
              /** 重新获取优化目标的选项 */
              this.downloadUrlChange();
            }

            this.resetDeliveryRangeForm();
            this.setAudienceFormProperty();
            this.setDeliverySettingFormProperty();
            this.setRoiGoalProperty();

            micro_promotion_type.on.change();
          },
        };

        // 【小游戏类型】事件监听
        micro_promotion_type.on = {
          change: () => {
            const is_micro_game = landing_type.value === 'MICRO_GAME';
            const is_byte_game = micro_promotion_type.value === 'BYTE_GAME';
            const is_wechat_game = micro_promotion_type.value === 'WECHAT_GAME';
            micro_app_instance_id.hidden = !(is_micro_game && (is_byte_game || is_wechat_game));
            micro_app_instance_id.label = is_wechat_game ? '微信小游戏' : '字节小游戏';
            micro_app_instance_id.rules.message = is_wechat_game ? '请选择微信小游戏' : '请选择字节小游戏';
            if (micro_promotion_type.value !== micro_promotion_type.backup_value) {
              micro_promotion_type.backup_value = micro_promotion_type.value;
              micro_app_instance_id.value = '';
              micro_app_instance_id.backup_value = '';
            }
            this.getMiniOptimizedGoal();
          },
        };

        /** 投放模式的事件监听 */
        delivery_mode.on = {
          change: () => {
            this.setInventoryCatalogProperty();
            this.setAudienceFormProperty();
            this.setDeliverySettingFormProperty();
            this.getMiniOptimizedGoal();
            this.setRoiGoalProperty();

            const { deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
            deep_external_action?.on?.change ? deep_external_action.on.change() : this.onDeepExternalActionChange();
          },
        };

        // 【定向包】事件监听
        this.audienceSetEvent();
        // 【排期与预算】监听事件
        this.deliverySettingSetEvent();
        // 【广告版位】监听事件
        this.deliveryRangeSetEvent();
        // 【渠道-渠道】事件监听
        alias.on = {
          change: () => {
            /** 设置渠道号 */
            this.setChannelCode({ channel_id: alias.value });
          },
        };
      }
    },
    /** 广告主账号选中事件 */
    async advertiserIdChange(val) {
      if (!this.projectData.advertiser_id) {
        return;
      }

      if (val) {
        const {
          promotion_batch_params,
          audience_form: {
            config: {
              audience: {
                children: {
                  crowd_pack_button,
                  crowd_pack,
                },
              },
            },
          },
        } = this.projectData;

        // 清空抖音号列表
        if (promotion_batch_params.length) {
          promotion_batch_params.forEach(e => {
            e.native_form.config.native_setting.children.aweme_id.value = '';
            e.native_form.config.native_setting.children.aweme_id.options = [];
          });
        }

        // 关闭自定义人群，用户打开后重新渲染并根据新的广告主更新人群包数据
        if (crowd_pack_button.value === 'CUSTOM') {
          crowd_pack_button.value = null;
          crowd_pack.hidden = true;
          crowd_pack.options = [];
          crowd_pack.value = {
            include: [],
            exclude: [],
          };
        }
      }

      await this.getAssetsList();
      await this.getMiniOptimizedGoal();
      this.$emit('forceUpdateDistrict');
      this.forceUpdateDistrict();
    },
    /** 推广子目标选中事件 */
    appPromotionTypeChange() {
      const { app_promotion_type, delivery_mode } = this.projectData.basic_set_form.config;
      if (app_promotion_type.hidden) {
        return;
      }
      const val = app_promotion_type.value;

      const {
        download_url,
        download_type,
        download_mode,
        launch_type,
        open_url,
        ulink_url,
        subscribe_url,
      } = this.projectData.target_form.config;
      const IS_LAUNCH_OR_DOWNLOAD = val === 'DOWNLOAD' || 'LAUNCH';
      const IS_LAUNCH = val === 'LAUNCH';
      const IS_RESERVE = val === 'RESERVE';
      const IS_DOWNLOAD = val === 'DOWNLOAD';

      download_url.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      download_type.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      download_mode.hidden = !IS_LAUNCH_OR_DOWNLOAD;
      launch_type.hidden = !IS_LAUNCH;
      open_url.hidden = !IS_LAUNCH;
      ulink_url.hidden = !IS_LAUNCH;
      subscribe_url.hidden = !IS_RESERVE;

      /** 应用下载或预约下载的时候显示 */
      delivery_mode.hidden = !(IS_DOWNLOAD || IS_RESERVE);

      this.resetDeliveryRangeForm();
      this.setAudienceFormProperty();
      this.setDeliverySettingFormProperty();
      this.setRoiGoalProperty();
    },
    /** 下载链接选择事件 */
    async downloadUrlChange(val) {
      const { advertiser_id } = this.projectData;
      const {
        ad_type,
        landing_type,
        app_promotion_type,
        delivery_mode,
      } = this.projectData.basic_set_form.config;
      const { optimize_goal } = this.projectData.optimize_form.config;
      const { download_url, platform } = this.projectData.target_form.config;
      let temp_asset = download_url.options.filter(item => item.value === download_url.value)[0];
      if (!temp_asset) {
        const asset_id = optimize_goal.children.asset_ids?.value[0];
        temp_asset = {
          asset_id: asset_id,
          package_name: optimize_goal.children.asset_ids.options.filter(item => item.value === asset_id)[0]?.package_name,
        };
      }

      // 被动触发清空值
      if (val !== undefined) {
        optimize_goal.children.external_action.value = '';
      }

      if (!temp_asset) {
        return;
      }

      optimize_goal.children.asset_ids.value = [temp_asset.asset_id];

      optimize_goal.children.deep_external_action.hidden = true;

      const is_app = landing_type.value === 'APP';
      is_app && this.getOptimizedGoalV2({
        advertiser_id,
        ad_type: ad_type.value,
        landing_type: landing_type.value,
        asset_type: landing_type.value,
        app_type: platform.value,
        app_promotion_type: app_promotion_type.value,
        package_name: temp_asset?.package_name,
        ...(!delivery_mode?.hidden && { delivery_mode: delivery_mode?.value }),
      });
    },
    /** 获取优化目标 */
    async getOptimizedGoalV2(params) {
      const { external_action, deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
      const { advertiser_id, landing_type, ad_type, asset_type } = params;
      const condition = [!external_action.is_loading, advertiser_id, landing_type, ad_type, asset_type].every(Boolean);
      if (condition) {
        try {
          external_action.is_loading = true;
          const convert_result = await getOptimizedGoalV2Api(params);
          external_action.options = convert_result.goals.map(item => {
            return {
              label: item.optimization_name,
              value: item.external_action,
              deep_goals: item.deep_goals,
              deep_bid_types: item.deep_bid_types,
            };
          });
          const is_valid_value = external_action.options.some(({ value }) => value === external_action.value);
          if (!is_valid_value) {
            external_action.value = '';
            deep_external_action.value = '';
            deep_external_action.hidden = true;
          }
        } finally {
          external_action.is_loading = false;
        }
      }
    },
    /** 行为兴趣类型选择事件 */
    interestActionChange() {
      const {
        action_days,
        action_scene,
        action_categories,
        interest_categories,
        interest_action_mode,
      } = this.projectData.audience_form.config.audience.children;

      const is_custom = interest_action_mode.value === 'CUSTOM';
      action_scene.hidden = !is_custom;
      action_days.hidden = !is_custom;
      action_categories.hidden = !is_custom;
      interest_categories.hidden = !is_custom;
      if (is_custom) {
        action_days.value = '30';
        action_scene.value = ['APP'];
        this.updateInterestAction();
      } else {
        this.resetInterestAction();
      }
    },
    /** 重置兴趣行为数据 */
    resetInterestAction(){
      const show_data = this.projectData.audience_form.config.audience.children;
      const arr = ['action_categories', 'action_words', 'interest_categories', 'interest_words'];
      arr.forEach(item => {
        show_data[item].hidden = true;
      });
    },
    /** 更新行为兴趣 */
    updateInterestAction() {
      const {
        action_days,
        action_scene,
        action_categories,
        interest_categories,
      } = this.projectData.audience_form.config.audience.children;
      const { advertiser_id } = this.projectData;
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      action_categories.hidden = true;
      this.interestAction({
        advertiser_id,
        action_scene: action_scene.value,
        action_days: action_days.value,
      }, 'getActionCategoryApi').then((res) => {
        action_categories.options = res.list;
        /** 行为类目词 */
        action_categories.hidden = false;
        if (is_procedural && !delivery_mode.hidden) {
          action_categories.hidden = true;
        }
      });

      interest_categories.hidden = true;
      this.interestAction({
        advertiser_id,
      }, 'getInterestCategoryApi').then((res) => {
        interest_categories.options = res.list;
        /** 兴趣类目词 */
        interest_categories.hidden = false;
        if ((is_micro_game || is_app) && is_procedural && !delivery_mode.hidden) {
          interest_categories.hidden = true;
        }
      });
    },
    /** 获取行为兴趣 */
    interestAction(params, api_key){
      return new Promise((resolve, reject) => {
        interestActionResource[api_key](params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /** 获取资产列表 */
    async getAssetsList() {
      const { landing_type } = this.projectData.basic_set_form.config;
      const { optimize_goal } = this.projectData.optimize_form.config;
      const { platform, download_url } = this.projectData.target_form.config;
      const { advertiser_id } = this.projectData;

      /** 推广目标是小游戏时，不需要请求资产列表 */
      if (landing_type.value === 'MICRO_GAME') {
        return;
      }

      return eventManager.getAssetsListApi({
        advertiser_id,
        asset_type: landing_type.value,
        app_type: platform.value,
      }).then((assets_result) => {
        download_url.options = assets_result.list.map(item => {
          return {
            label: item.name,
            value: item.download_url,
            asset_id: item.asset_id,
            app_type: item.app_type,
            package_name: item.package_name,
            package_id: item.package_id,
          };
        });

        optimize_goal.children.asset_ids.options = assets_result.list.map(item => {
          return {
            label: item.asset_name,
            value: item.asset_id,
            package_name: item.package_name,
          };
        });
      });
    },
    /** 打开资产框 */
    openAssetBox() {
      const { advertiser_id } = this.projectData;
      const { landing_type } = this.projectData.basic_set_form.config;
      const { platform } = this.projectData.target_form.config;

      this.event_asset_box_params.tablep = {
        advertiser_id,
        landing_type: landing_type.value,
        app_type: platform.value,
      };

      this.event_asset_box_params.is_show = true;
    },
    /** 事件弹框确定回调 */
    async eventAssetConfirm(temp_asset) {
      const { advertiser_id } = this.projectData;
      const {
        ad_type,
        landing_type,
        app_promotion_type,
        delivery_mode,
      } = this.projectData.basic_set_form.config;
      const { optimize_goal } = this.projectData.optimize_form.config;
      const { download_url, platform } = this.projectData.target_form.config;

      this.event_asset_box_params.is_show = false;
      download_url.value = temp_asset.download_url;
      download_url.app_name = temp_asset.name;

      optimize_goal.children.asset_ids.value = [temp_asset.asset_id];
      optimize_goal.children.external_action.value = '';
      optimize_goal.children.deep_external_action.hidden = true;
      this.setChannelCode(temp_asset);
      this.getOptimizedGoalV2({
        advertiser_id,
        ad_type: ad_type.value,
        landing_type: landing_type.value,
        asset_type: landing_type.value,
        app_type: temp_asset?.app_type ? temp_asset?.app_type : platform.value,
        app_promotion_type: app_promotion_type.value,
        package_name: temp_asset?.package_name,
        ...(!delivery_mode?.hidden && { delivery_mode: delivery_mode?.value }),
      });
    },
    /**
     * 打开模板弹窗
     * @param {string} type 模板类型
     * @param {number} index 模板下标
     */
    async openTemplateDialog(type, index) {
      let is_validate = false;
      if (type === 'project') {
        is_validate = await this.validateAllForm(false, false);
      } else {
        this.project_template = {};
        is_validate = await this.$refs.project_form[index].confirm(false, false);
      }

      Object.assign(this.template_dialog_config, {
        is_show: true,
        is_validate,
        type,
        name: '',
      });
    },
    /** 模板弹窗确认 */
    async confirmTemplateDialog() {
      const type = this.template_dialog_config.type;

      if (!this.template_dialog_config.name) {
        this.$message.warning('请输入模板名称！');
        return;
      }
      // 保存广告通配符【定向包】或【广告版位】的数据
      if (type === 'audience_form' || type === 'delivery_range_form') {
        this.projectData.project_config.ad_wildcard[type === 'audience_form' ? 'audience_template_name' : 'delivery_range_template_name'] = this.template_dialog_config.name;
      }
      // 保存【投放内容与目标-应用名称】【优化目标-事件资产】
      if (this.project_template?.download_url) {
        const { app_name } = this.projectData.target_form.config.download_url;
        const { asset_ids } = this.projectData.optimize_form.config.optimize_goal.children;
        this.project_template.app_name = app_name;
        this.project_template.asset_ids = asset_ids.value;
      }
      // 保存微信/字节小游戏基础信息，用于后续回显
      if (this.project_template?.micro_app_instance_id) {
        const { micro_app_instance_id } = this.projectData.target_form.config;
        this.project_template.micro_app_instance_id = micro_app_instance_id.backup_value;
      }
      const params = {
        advertiser: 'jrtt',
        type: this.template_type_map[type],
        name: this.template_dialog_config.name,
        template_data: JSON.stringify(this.project_template),
      };
      templateResource.addTemplateData(params).then(res => {
        this.$message.success(res.message);
      });
      this.template_dialog_config.is_show = false;
    },
    /**
     * 打开模板列表
     * @param {string} type 模板类型
     */
    openTemplateList(type) {
      Object.assign(this.template_list_config, {
        is_show: true,
        type,
      });
    },
    /**
     * 应用模板
     * @param {string} data 模板数据
     */
    async applicationTemplate(data) {
      this.template_list_config.is_loading = true;
      const type = this.template_list_config.type;

      // 获取广告通配符【定向包】或【广告版位】的数据
      if (type === 'audience_form' || type === 'delivery_range_form') {
        this.projectData.project_config.ad_wildcard[type === 'audience_form' ? 'audience_template_name' : 'delivery_range_template_name'] = data.split(' - ')[0];
      }
      const template_data = JSON.parse(data.split(' - ')[1]);
      // 格式化模板数据
      this.templateFormat(template_data);
      // 表单赋值
      if (type === 'project') {
        Object.assign(this.projectData, { advertiser_id: template_data.advertiser_id });
        for (const key in this.projectFilterData) {
          formDataAssign(this.projectData[key].config, template_data);
        }
      } else {
        formDataAssign(this.projectData[type].config, template_data);
      }
      // 格式化【定向包】表单
      template_data?.audience && this.formatAudienceForm(template_data.audience);
      // 【投放内容与目标】
      if (type === 'project' || type === 'target_form') {
        const { download_url } = this.projectData.target_form.config;
        const { asset_ids } = this.projectData.optimize_form.config.optimize_goal.children;
        // 获取【投放内容与目标-应用名称】
        download_url.app_name = template_data?.app_name ? template_data.app_name : '';
        // 获取【优化目标-事件资产】
        if (template_data?.download_url) {
          asset_ids.value = template_data.asset_ids;
        }

        // 【小游戏类型】同步backup_value
        const { micro_promotion_type } = this.projectData.target_form.config;
        micro_promotion_type.backup_value = micro_promotion_type.value;
      }

      // 执行change方法列表
      await this.handleChangeList();

      this.resetDeliveryRangeForm();
      this.setAudienceFormProperty();
      this.setDeliverySettingFormProperty();
      this.setRoiGoalProperty();

      Object.assign(this.template_list_config, {
        is_loading: false,
        is_show: false,
      });
    },
    /** 表单回调 */
    onSubmit(params) {
      if (this.template_dialog_config.type === 'project') {
        const { advertiser_id } = this.projectData;
        Object.assign(this.project_template, { advertiser_id });
      }
      Object.assign(this.project_template, params);

      // 格式化提交参数
      this.submitFormat();
    },
    /**
     * 效验所有表单
     * @param is_validate 是否效验数据
     * @param is_filter_empty 是否过滤空值
     */
    async validateAllForm(is_validate = true, is_filter_empty = true) {
      this.template_dialog_config.type = 'project';
      let is_succeed = false;
      let is_all_succeed = true;
      this.project_template = {};

      for (let i = 0; i < this.$refs.project_form.length; i++) {
        const item = this.$refs.project_form[i];
        is_succeed = await item.confirm(is_validate, is_filter_empty);
        if (!is_succeed) {
          is_all_succeed = is_succeed;
          if (is_validate) {
            break;
          }
        }
      }

      return is_all_succeed;
    },
    /** 获取change方法列表 */
    getChangeList(config) {
      let change_list = [];
      for (const config_key in config) {
        // 跳过游戏change方法
        if (config_key === 'game_id') {
          continue;
        }
        const item = config[config_key];
        if (config[config_key].children) {
          const config_list = this.getChangeList(item.children);
          change_list = [
            ...change_list,
            ...config_list,
          ];
        } else if (item.on?.change){
          change_list.push(item.on.change);
        }
      }

      return change_list;
    },
    /** 执行change方法列表 */
    async handleChangeList(){
      let event_list = [];
      for (const key in this.projectFilterData) {
        const config = this.projectData[key]?.config;
        if (config) {
          const change_list = this.getChangeList(config);

          if (change_list.length){
            event_list = [
              ...event_list,
              ...change_list,
            ];
          }
        }
      }
      try {
        for (let i = 0; i < event_list.length; i++) {
          await event_list[i]();
        }
      } catch (error) {
        console.log(error);
      }
    },
    /** 格式化【定向包】表单 - 部分参数提交时被过滤，模板回显时需重置 */
    formatAudienceForm(audience) {
      const {
        age, // 年龄
        platform, // 平台
        android_osv, // 安卓版本
        ios_osv, // ios版本
        device_type, // 设备类型
        ac, // 网络
        crowd_pack_button, // 自定义人群 - is_filter
        phone_prices, // 手机价格 - is_filter
        device, // 手机品牌 - is_filter
        auto_extend_enabled, // 智能放量 - is_filter
      } = this.projectData.audience_form.config.audience.children;

      // 参数不存在时初始化数据
      !audience?.age && (age.value = [null]);
      !audience?.platform && (platform.value = null);
      !audience?.android_osv && (android_osv.value = '');
      !audience?.ios_osv && (ios_osv.value = '');
      !audience?.device_type && (device_type.value = null);
      !audience?.ac && (ac.value = [null]);

      // 初始化操作按钮
      crowd_pack_button.value = audience?.crowd_pack ? 'CUSTOM' : null;
      phone_prices.value = audience?.launch_price ? 'CUSTOM' : null;
      device.value = audience?.device_brand ? 'CHOOSE_BRAND' : null;
      auto_extend_enabled.value = audience?.auto_extend_targets ? 1 : 0;
    },
    /** 【定向包】监听事件 */
    audienceSetEvent() {
      const {
        district,
        city,
        location_type,
        region_version,
        age,
        ac,

        auto_extend_enabled,
        auto_extend_targets,

        /** 设备 */
        device,
        device_brand,
        phone_prices,
        launch_price,

        /** 行为 */
        interest_action_mode,
        action_days,

        /** 人群包 */
        crowd_pack_button,
        crowd_pack,

        hide_if_converted,
        converted_time_duration,
      } = this.projectData.audience_form.config.audience.children;

      // 手机价格快捷设置方法
      launch_price.quickSetting = (val) => {
        launch_price.value = val;
      };

      const mapTuple = [
        // 年龄
        [
          age,
          {
            change: (val) => {
              if (val) {
                age.value = checkboxFilterNone(val);
              }
            },
          },
        ],
        // 网络
        [
          ac,
          {
            change: (val) => {
              if (val) {
                ac.value = checkboxFilterNone(val);
              }
            },
          },
        ],
        // 地域类型
        [
          district,
          {
            change: () => {
              city.hidden = true;
              const is_none = district.value === 'NONE';
              if (is_none) {
                city.value = [];
                location_type.value = 'CURRENT';
              }
              location_type.hidden = is_none;
              region_version.hidden = is_none;
              // 重新渲染组件，避免读取模板后数据显示异常
              this.$nextTick(() => {
                city.hidden = is_none;
              });
            },
          },
        ],
        // 人群包
        [
          crowd_pack_button,
          {
            change: () => {
              if (crowd_pack_button.value === null) {
                crowd_pack.value = {
                  include: [],
                  exclude: [],
                };
              }
              crowd_pack.hidden = crowd_pack_button.value === null;
            },
          },
        ],
        // 过滤已转化用户
        [
          hide_if_converted,
          {
            change: () => {
              if (
                hide_if_converted.value === 'APP' ||
                hide_if_converted.value === 'CUSTOMER' ||
                hide_if_converted.value === 'ORGANIZATION'
              ) {
                converted_time_duration.hidden = false;
              } else {
                converted_time_duration.hidden = true;
              }
            },
          },
        ],
        // 设备
        [
          device,
          {
            change: () => {
              device_brand.hidden = true;
              // 重新渲染组件，避免读取模板后数据显示异常
              this.$nextTick(() => {
                device_brand.hidden = device.value === null;
              });
            },
          },
        ],
        // 手机价格
        [
          phone_prices,
          {
            change: () => {
              launch_price.hidden = phone_prices.value === null;
              if (phone_prices.value === null) {
                launch_price.value = [];
              } else if (launch_price.value.length === 0) {
                launch_price.value = [0, 110000];
              }
            },
          },
        ],
        // 行为兴趣
        [interest_action_mode, { change: this.interestActionChange }],
        // 智能放量
        [
          auto_extend_enabled,
          {
            change: () => {
              auto_extend_targets.hidden = true;
              this.$nextTick(() => {
                auto_extend_targets.hidden = !auto_extend_enabled.value;
              });
            },
          },
        ],
        // 用户发生行为天数
        [
          action_days,
          {
            change: (val) => {
              if (val) {
                this.updateInterestAction();
              }
            },
          },
        ],
      ];
      mapTuple.forEach(([m, n]) => (m.on = n));
    },
    /** 【排期与预算】监听事件 */
    deliverySettingSetEvent() {
      const {
        schedule_type,
        start_time,
        schedule_time,
        bid_type,
        budget_mode,
        budget,
        budget_optimize_switch,
        cpa_bid,
        deep_bid_type,
      } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;

      // 投放时间类型事件处理
      schedule_type.on = {
        change: () => {
          const is_custom = schedule_type.value === 'SCHEDULE_START_END';
          start_time.hidden = !is_custom;
          schedule_time.hidden = !is_custom;
        },
      };

      /** 竞价策略事件处理 */
      bid_type.on = {
        change: () => {
          const is_custom = budget_mode.value === 'BUDGET_MODE_DAY';
          const is_no_bid = bid_type.value === 'NO_BID';
          const is_procedural = delivery_mode.value === 'PROCEDURAL';

          budget_optimize_switch.disabled = !!(!delivery_mode.hidden && is_procedural);
          /** 当bid_type=NO_BID且BUDGET=BUDGET_MODE_DAY时,“预算择优分配”必填; */
          budget_optimize_switch.hidden = !(is_custom && is_no_bid);

          /** 当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME时不支持OFF */
          budget_optimize_switch.value = (!delivery_mode.hidden && is_procedural) ? 'ON' : budget_optimize_switch.value;

          /** 目标转化出价/预期成本。当 bid_type = NO_BID时，不支持该字段；当delivery_mode = PROCEDURAL &&landing_type = APP/MICRO_GAME/LINK时必填； */
          cpa_bid.hidden = !(!delivery_mode.hidden && is_procedural && !is_no_bid && (landing_type.value === 'APP' || landing_type.value === 'MICRO_GAME'));

          this.setRoiGoalProperty();

          deep_bid_type?.on?.change?.();
        },
      };

      // 预算类型事件处理
      budget_mode.on = {
        change: () => {
          const is_custom = budget_mode.value === 'BUDGET_MODE_DAY';
          const is_no_bid = bid_type.value === 'NO_BID';
          budget_optimize_switch.hidden = !(is_custom && is_no_bid);
          budget.hidden = !is_custom;
        },
      };
    },
    /** 【广告版位】监听事件 */
    deliveryRangeSetEvent() {
      const {
        inventory_catalog,
        inventory_type,
        union_video_type,
      } = this.projectData.delivery_range_form.config.delivery_range.children;

      // 广告位大类
      inventory_catalog.on = {
        change: (val) => {
          const is_manual = inventory_catalog.value === 'MANUAL';
          inventory_type.hidden = !is_manual;

          if (val !== undefined) {
            inventory_type.value = [];
          }
        },
      };

      // 广告投放位置
      inventory_type.on = {
        change: (val) => {
          const is_manual = inventory_catalog.value === 'MANUAL';
          union_video_type.hidden = !(is_manual && inventory_type?.value?.toString() === 'INVENTORY_UNION_SLOT');
        },
      };
    },
    /** 格式化提交参数 */
    submitFormat() {
      const start_time = this.project_template?.delivery_setting?.start_time;
      const crowd_pack = this.project_template?.audience?.crowd_pack;

      // 【投放时间】
      if (isArray(start_time)) {
        Object.assign(this.project_template.delivery_setting, {
          start_time: start_time[0],
          end_time: start_time[1],
        });
      }

      // 【自定义人群包】
      if (crowd_pack) {
        const { include, exclude } = crowd_pack;
        // 定向
        if (include.length) {
          Object.assign(this.project_template.audience, {
            retargeting_tags_include: include.map(item => item.custom_audience_id),
          });
        }
        // 排除
        if (exclude.length) {
          Object.assign(this.project_template.audience, {
            retargeting_tags_exclude: exclude.map(item => item.custom_audience_id),
          });
        }
        delete this.project_template.audience.crowd_pack;
      }

      // 小游戏
      if (this.project_template?.micro_app_instance_id) {
        const data = JSON.parse(this.project_template.micro_app_instance_id);
        // 字节小游戏
        if (this.project_template?.micro_promotion_type === 'BYTE_GAME') {
          data?.micro_app_instance_id && (this.byte_game_backup = data);
          (this.byte_game_backup?.asset_id && this.project_template?.optimize_goal) && Object.assign(this.project_template.optimize_goal, { asset_ids: [this.byte_game_backup.asset_id] });
        }
        data?.micro_app_instance_id && (this.project_template.micro_app_instance_id = data.micro_app_instance_id);
      }
    },
    /**
     * 格式化模板参数
     * @param {Object} template_data 模板数据
     */
    templateFormat(template_data) {
      const is_has_audience = !!template_data?.audience;
      const is_has_delivery_setting = !!template_data?.delivery_setting;

      // 定向包 -【自定义人群包】
      if (is_has_audience) {
        const { retargeting_tags_include = [], retargeting_tags_exclude = [] } = template_data.audience;
        const { crowd_pack: { options = [] }, crowd_pack_button } = this.projectData.audience_form.config.audience.children;
        if (retargeting_tags_include.length || retargeting_tags_exclude.length) {
          // 自定义人群
          const is_custom = crowd_pack_button.value === 'CUSTOM';
          const crowd_pack = {
            include: options.length ? retargeting_tags_include.map(item => options.find(option => option.custom_audience_id === item)).filter(item => item) : (is_custom ? [] : retargeting_tags_include),
            exclude: options.length ? retargeting_tags_exclude.map(item => options.find(option => option.custom_audience_id === item)).filter(item => item) : (is_custom ? [] : retargeting_tags_exclude),
          };
          Object.assign(template_data.audience, {
            crowd_pack,
          });
          delete template_data.audience.retargeting_tags_include;
          delete template_data.audience.retargeting_tags_exclude;
        }
      }

      // 排期与预算 -【投放时间】
      if (is_has_delivery_setting) {
        const { start_time, end_time } = template_data.delivery_setting;
        if (start_time && end_time) {
          template_data.delivery_setting.start_time = [start_time, end_time];
          delete template_data.delivery_setting.end_time;
        }
      }
    },
    /** 设置游戏数据 */
    setGameData(games) {
      const { alias = {}} = this.projectData.channel_form.config.channel.children;
      !alias.extra_data && this.initChannelExtraData();
      this.$set(alias, 'extra_data', Object.assign(alias.extra_data || {}, { games }));
    },
    /**
     * 获取渠道详情
     * @param {Object} params 请求参数
     * @example getChannelDetails({channels:['jrtt101']})
     */
    getChannelDetails(params) {
      return new Promise((resolve, reject) => {
        getChannelDetailsApi(params).then(res => {
          resolve(res.list);
        }).catch(reject);
      });
    },
    /** 初始化渠道额外数据结构 */
    initChannelExtraData() {
      const { alias } = this.projectData.channel_form.config.channel.children;
      this.$set(alias, 'extra_data', { channel_details: {}, games: [] });
    },
    /** 设置渠道号 */
    setChannelCode(asset_data) {
      const { channel_id = '' } = asset_data;
      const { alias } = this.projectData.channel_form.config.channel.children;
      !alias.extra_data && this.initChannelExtraData();
      Object.keys(alias.extra_data.channel_details).forEach(key => this.$delete(alias.extra_data.channel_details, key));
      const resetChannelAlias = () => (alias.value = '');
      channel_id ? this.getChannelDetails({ channels: [channel_id] }).then((res) => {
        if (!res.length) {
          this.$message.warning('渠道不存在！');
          resetChannelAlias();
          return;
        }
        const [channel_details] = res;
        alias.value = channel_details.alias;
        this.$set(alias, 'extra_data', Object.assign(alias.extra_data || {}, { channel_details }));
      }).catch(resetChannelAlias) : resetChannelAlias();
    },
    /** 重置广告版位表单 */
    resetDeliveryRangeForm() {
      const { delivery_mode } = this.projectData.basic_set_form.config;
      this.setInventoryCatalogProperty();
      if (!delivery_mode.hidden) {
        /** 手动执行【投放模式】change事件 */
        delivery_mode?.on?.change?.();
      }
    },
    /** 设置定向包表单项属性 */
    setAudienceFormProperty() {
      const {
        device_brand,
        device,
        phone_prices,
        launch_price,
        auto_extend_enabled,
        auto_extend_targets,
        hide_if_exists,
        ac,
        device_type,
        android_osv,
        ios_osv,
        interest_action_mode,
        action_scene,
        action_days,
      } = this.projectData.audience_form.config.audience.children;
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;
      const not_procedural = delivery_mode.value !== 'PROCEDURAL';
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      /** 按品牌选择 */
      const is_choose_brand = device.value === 'CHOOSE_BRAND';

      /** 手机品牌 */
      device.hidden = false;
      device_brand.hidden = !is_choose_brand;

      /** 手机价格 */
      const is_phone_prices_custom = phone_prices.value === 'CUSTOM';
      phone_prices.hidden = false;
      launch_price.hidden = !is_phone_prices_custom;

      /** 智能放量 */
      const is_auto_extend_enabled = auto_extend_enabled.value === 1;
      auto_extend_enabled.hidden = false;
      auto_extend_targets.hidden = !is_auto_extend_enabled;

      /** 过滤已安装 */
      hide_if_exists.hidden = false;
      hide_if_exists.options = [
        { label: '不限', value: 'UNLIMITED', disabled: false },
        { label: '过滤', value: 'FILTER', disabled: false },
        { label: '定向', value: 'TARGETING', disabled: false },
      ];

      /** 网络 */
      ac.hidden = false;
      /** 设备类型 */
      device_type.hidden = false;
      /** 安卓版本 */
      android_osv.hidden = false;
      /** IOS版本 */
      ios_osv.hidden = false;
      /** 行为兴趣 */
      interest_action_mode.hidden = false;
      this.interestActionChange();
      this.projectData.audience_form.title = '定向包';
      try {
        const map_tuple = [
          /** 【投放模式】为显示状态 */
          [
            () => !delivery_mode.hidden,
            () => {
              /** 手机品牌 */
              device.hidden = !not_procedural;
              device_brand.hidden = !(not_procedural && is_choose_brand && !device.hidden);

              /** 手机价格 */
              phone_prices.hidden = !not_procedural;
              launch_price.hidden = !(not_procedural && is_phone_prices_custom && !phone_prices.hidden);

              /** 智能放量 */
              auto_extend_enabled.hidden = !not_procedural;
              auto_extend_targets.hidden = !(not_procedural && is_auto_extend_enabled && !auto_extend_enabled.hidden);
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是应用并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_app && is_procedural,
            () => {
              hide_if_exists.options = [
                { label: '不限', value: 'UNLIMITED', disabled: false },
                { label: '过滤', value: 'FILTER', disabled: false },
              ];
              hide_if_exists.value = hide_if_exists.value === 'TARGETING' ? 'UNLIMITED' : hide_if_exists.value;
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是小游戏并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_micro_game && is_procedural,
            () => {
              hide_if_exists.hidden = true;
              android_osv.hidden = true;
              ios_osv.hidden = true;
            },
          ],
          /** 【投放模式】为显示状态并且【推广目的】是小游戏/应用并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && (is_micro_game || is_app) && is_procedural,
            () => {
              ac.hidden = true;
              device_type.hidden = true;
              interest_action_mode.hidden = true;
              action_scene.hidden = true;
            },
          ],
          /** 【投放模式】为显示状态并且【投放模式】是自动投放 */
          [
            () => !delivery_mode.hidden && is_procedural,
            () => {
              action_days.hidden = true;
              this.projectData.audience_form.title = '受众倾向与过滤';
            },
          ],
        ];
        map_tuple.forEach(([condition, handler]) => (condition() && handler()));
      } catch (reason) {
        throw new Error(reason);
      }
    },
    /** 设置排期与预算表单项属性 */
    setDeliverySettingFormProperty() {
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;
      const { budget_mode, bid_type } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      /** 当 delivery_mode = PROCEDURAL && landing_type = APP/MICRO_GAME/LINK时仅支持日预算 */
      budget_mode.value = (is_procedural && (is_app || is_micro_game)) ? 'BUDGET_MODE_DAY' : budget_mode.value;
      budget_mode.disabled = !!((is_procedural && !delivery_mode.hidden));
      budget_mode.on?.change?.();
      bid_type.on?.change?.();
    },
    /** 更新行政区域数据 */
    async forceUpdateDistrict() {
      const { advertiser_id } = this.projectData;
      const { city, region_version } = this.projectData.audience_form.config.audience.children;
      city.options.splice(0);
      region_version.options.splice(0);
      region_version.value = '';
      const { districts = [], version = [] } = this.sharing_districts_map?.[advertiser_id] || {};
      const copy_districts = clone(districts);
      const copy_version = clone(version);
      region_version.options = copy_version;
      city.options = copy_districts;
      region_version.value = copy_version.at(0)?.value;
    },
    /** 设置深度转化ROI系数 */
    setRoiGoalProperty() {
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;
      const { roi_goal, bid_type } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const { deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const is_roi = deep_external_action.value === 'AD_CONVERT_TYPE_PURCHASE_ROI' || deep_external_action.value === 'AD_CONVERT_TYPE_PURCHASE_ROI_7D';
      /** 竞价策略是否是最大转化投放 */
      const is_no_bid = bid_type.value === 'NO_BID';
      /** 深度转化ROI系数, 范围(0,5]，精度：保留小数点后四位，当delivery_mode = PROCEDURAL && landing_type = APP/MICRO_GAME时 && 深度优化目标为付费ROI或付费ROI-7日时必填，当delivery_mode =MANUAL时填写报错 */
      roi_goal.hidden = !(is_procedural && !delivery_mode.hidden && (is_app || is_micro_game) && is_roi && !deep_external_action.hidden && !is_no_bid);
    },
    /** 获取可用深度优化方式 */
    getDeepBidType() {
      return new Promise((resolve, reject) => {
        const { advertiser_id } = this.projectData;
        const { landing_type, delivery_mode } = this.projectData.basic_set_form.config;
        const { external_action, deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
        getDeepBidTypeApi({
          advertiser_id,
          ...(!delivery_mode.hidden && { delivery_mode: delivery_mode.value }),
          landing_type: landing_type.value,
          external_action: external_action.value,
          ...(!deep_external_action.hidden && deep_external_action.value ? { deep_external_action: deep_external_action.value } : {}),
        }).then(resolve).catch(reject);
      });
    },
    /** 设置深度优化方式属性 */
    setDeepBidTypeProperty() {
      const { deep_bid_type } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const { advertiser_id } = this.projectData;
      const { external_action } = this.projectData.optimize_form.config.optimize_goal.children;
      if (advertiser_id && external_action.value && !deep_bid_type.is_loading) {
        deep_bid_type.is_loading = true;
        this.getDeepBidType().then(res => {
          deep_bid_type.hidden = res.deep_bid_type.length === 0;
          deep_bid_type.options = store.getters.jrttEnum.api_2_deep_bid_type.filter(({ value }) => res.deep_bid_type.includes(value));
          /** 深度优化方式数据源如果存在【每次付费出价】选项时默认选中【每次付费出价】 */
          deep_bid_type.value = deep_bid_type.options.some(deep => deep.value === 'BID_PER_ACTION') ? 'BID_PER_ACTION' : deep_bid_type.value;
          /** 深度优化方式数据源如果不包含【deep_bid_type.value】则默认选取第一个选项 */
          deep_bid_type.value = deep_bid_type.options.some(deep => deep.value === deep_bid_type.value) ? deep_bid_type.value : deep_bid_type.options[0]?.value;
          deep_bid_type?.on?.change?.();
        }).finally(() => {
          deep_bid_type.is_loading = false;
        });
      }
    },
    /** 监听深度优化目标 */
    onDeepExternalActionChange() {
      const { deep_bid_type } = this.projectData.delivery_setting_form.config.delivery_setting.children;
      const { deep_external_action } = this.projectData.optimize_form.config.optimize_goal.children;
      /** 如果深度优化目标有值 */
      if (deep_external_action.value && !deep_external_action.hidden) {
        this.setDeepBidTypeProperty();
      } else {
        deep_bid_type.hidden = true;
      }
      deep_bid_type?.on?.change?.();
      this.setRoiGoalProperty();
    },
    /** 设置【广告版位】表单属性 */
    setInventoryCatalogProperty() {
      const { inventory_catalog, inventory_type } = this.projectData.delivery_range_form.config.delivery_range.children;
      const { delivery_mode, landing_type } = this.projectData.basic_set_form.config;
      const is_procedural = delivery_mode.value === 'PROCEDURAL';
      const is_app = landing_type.value === 'APP';
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const all_options = [{ label: '首选媒体', value: 'MANUAL' }, { label: '通投智选', value: 'UNIVERSAL_SMART' }];
      const condition = (is_procedural && !delivery_mode.hidden && (is_micro_game || is_app));
      inventory_catalog.options = condition ? [all_options.at(1)] : [all_options.at(0)];
      inventory_catalog.value = inventory_catalog.options.at(0).value;
      inventory_catalog.on?.change?.();
      inventory_type.on?.change?.();
    },
    /** 打开小程序资产弹窗 */
    openMiniProgramAssets() {
      const { micro_promotion_type } = this.projectData.target_form.config;
      Object.assign(this.mini_program_assets_dialog_config, {
        is_show: true,
        mg_type: micro_promotion_type.value,
      });
    },
    /**
     * 确认小程序资产弹窗
     * @param {Object} data 资产数据
     */
    miniProgramAssetsConfirm(data) {
      this.mini_program_assets_dialog_config.is_show = false;
      const { micro_app_instance_id } = this.projectData.target_form.config;
      micro_app_instance_id.value = JSON.stringify(data);
      micro_app_instance_id.backup_value = JSON.stringify(data); // 用于模板存储
      const { promotion_batch_params } = this.projectData;
      // 清空小游戏链接
      if (promotion_batch_params.length) {
        promotion_batch_params.forEach(e => {
          e.material_form.config.promotion_materials.children.mini_program_info_url.value = '';
        });
      }
      this.getMiniOptimizedGoal();
    },
    /** 推广目标为小游戏时获取优化目标 */
    async getMiniOptimizedGoal() {
      const { advertiser_id } = this.projectData;
      const { ad_type, landing_type, delivery_mode } = this.projectData.basic_set_form.config;
      const { micro_promotion_type, micro_app_instance_id } = this.projectData.target_form.config;
      const is_micro_game = landing_type.value === 'MICRO_GAME';
      const is_wechat_game = is_micro_game && micro_promotion_type.value === 'WECHAT_GAME' && micro_app_instance_id.value;
      const is_byte_game = is_micro_game && micro_promotion_type.value === 'BYTE_GAME' && micro_app_instance_id.value;
      if (is_wechat_game || is_byte_game) {
        await this.getOptimizedGoalV2({
          advertiser_id,
          ad_type: ad_type.value,
          landing_type: landing_type.value,
          asset_type: is_wechat_game ? 'ORANGE' : 'MINI_PROGRAM', // 优化目标为头条V2接口，修正了单词错误
          ...(!delivery_mode?.hidden && { delivery_mode: delivery_mode?.value }),
          micro_app_instance_id: JSON.parse(micro_app_instance_id.value).micro_app_instance_id,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.project-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  .project-column{
    flex: 1;
  }
  .col-2 {
    min-width: 700px;
  }
}
/deep/ .channel-tag-card {
  float: left;
  width: 300px;
  margin-top: 10px;
  .el-card__header {
    padding: 10px 20px;
  }
  .el-card__body {
    padding: 10px 20px;
    height: 325px;
    overflow: auto;
  }
}
</style>
